import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "left"
};
const _hoisted_2 = {
  class: "right"
};
const _hoisted_3 = {
  class: "el-dropdown-link"
};
import { useStore } from "vuex";
import { Menu, User } from "@element-plus/icons-vue";
import { useRouter } from "vue-router";
export default {
  __name: 'TopHerder',
  setup(__props) {
    const store = useStore();
    const router = useRouter();
    // const handleCollapsed = () => {
    //   store.commit("changeCollapsed");
    // };

    // const handleCenter = () => {
    //   router.push("/center");
    // };

    const handleLogout = () => {
      localStorage.removeItem("token");
      // store.commit("clearUserInfo");
      router.push("/");
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_arrow_down = _resolveComponent("arrow-down");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_header = _resolveComponent("el-header");
      return _openBlock(), _createBlock(_component_el_header, null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_icon, {
          size: "25px"
        }, {
          default: _withCtx(() => [_createVNode(_unref(Menu))]),
          _: 1
        }), _cache[0] || (_cache[0] = _createElementVNode("span", {
          style: {
            "margin-left": "10px"
          }
        }, "贵州民生溯源科技有限公司", -1))]), _createElementVNode("div", _hoisted_2, [_createElementVNode("span", null, "欢迎回来：" + _toDisplayString(_unref(store).state.userInfo.realName), 1), _createVNode(_component_el_dropdown, null, {
          dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
              onClick: handleLogout
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("退出登录")])),
              _: 1
            })]),
            _: 1
          })]),
          default: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_icon, {
            size: "30px",
            color: "#2d3a4b"
          }, {
            default: _withCtx(() => [_createVNode(_unref(User))]),
            _: 1
          }), _createVNode(_component_el_icon, {
            class: "el-icon--right"
          }, {
            default: _withCtx(() => [_createVNode(_component_arrow_down)]),
            _: 1
          })])]),
          _: 1
        })])]),
        _: 1
      });
    };
  }
};